export interface CreateProjectNoteInput {
    description: string
    dueDate?: Date
    name: string
    projectId?: string
    noteComment: ProjectNoteInputComment
    noteType: string
    state: string
    id?: string
    projectElementDescription: string
    projectElementId?: string | null
    isProductTypeProperty?: boolean
    projectProductFamilyId?: string
    contentItemId?: string
}
export interface UpdateProjectNoteInput {
    description: string
    name: string | null
    projectId?: string
    id?: string
    noteType?: string
    contentItemId?: string | null
    state?: string
}
export interface SetProjectNoteStateInput {
    state: string
    id?: string
}
export enum UpdateBehavior {
    AUTOMATIC,
    MANUAL,
    NEVER,
}
export interface ProjectNoteInputComment {
    projectId?: string
    text: string
}
export interface ProjectNoteMetaData {
    created?: Date
    creatorId: string
    updated: Date
}

export interface ProjectNoteComment {
    dataType: string
    firmId: string
    id: string
    metadata: ProjectNoteMetaData
    partitionKey: string
    projectId?: string
    projectNoteId: string
    shouldSerializeFirmId: boolean
    shouldSerializePartitionKey: boolean
    siteId: string
    text: string
}
export interface RemoveProjectCommentInput {
    projectId?: string
    projectNoteId: string
    projectNoteCommentId: string
}
export interface RemoveProjectNoteInput {
    projectId?: string
    projectNoteId: string
}
export interface AddProjectNoteCommentInput {
    projectId?: string
    projectNoteId: string
    text: string
}

export interface ProjectNote {
    comments: Partial<ProjectNoteComment>[]
    dataType: string
    description: string
    dueDate?: Date
    firmId: string
    id: string
    name: string
    noteType: NoteType
    partitionKey: string
    projectId: string
    metadata: ProjectNoteMetaData
    projectNoteCommentIds: string[]
    shouldSerializeFirmId: boolean
    shouldSerializePartitionKey: boolean
    siteId: string
    state: string
    projectElementDescription: string
    projectElementId: string
    noteBreadCrumbs: string[]
    contentItemId: string
    isProductTypeProperty: boolean
}

export interface ProjectNoteSearchInputFilter {
    noteAuthorSearch: string
    noteLastModifiedSearch: string
    noteNameSearch: string
    noteProjectElementDescriptionSearch: string
    contentItemId: string
    elementId: string
    projectNoteState: NoteState
    projectProductFamilyId: string
}
export interface ProjectNoteSearchInput {
    filter: Partial<ProjectNoteSearchInputFilter>
    limit: number
    skip: number
}

export enum NoteState {
    NEW = 'NEW',
    ACTIVE = 'ACTIVE',
    REVIEWNEEDED = 'REVIEWNEEDED',
    COORDINATIONNEEDED = 'COORDINATIONNEEDED',
    REVIEWINPROGRESS = 'REVIEWINPROGRESS',
    APPROVED = 'APPROVED',
    COMPLETE = 'COMPLETE',
}

export enum NoteType {
    GeneralProject = 'GeneralProject',
    Assembly = 'Assembly',
    Family = 'Family',
    ProductType = 'ProductType',
    ProductTypeProperty = 'ProductTypeProperty',
}

export const NOTE_TYPE_PREFIX_RE = /^(Family|Assembly|Product\s*Type\s-)\s+/i
